import { useAuthStore } from '@/lib/auth/store'
import { Navigate, createFileRoute } from '@tanstack/react-router'
import type { JSX } from 'react'

export const Route = createFileRoute('/')({
  component: Index,
})

// Ruta raíz: redirige al dashboard si está autenticado, o al login si no.
// Los silent refreshes los maneja el guard de _app/ — aquí solo decidimos dirección.
function Index(): JSX.Element {
  const accessToken = useAuthStore((s) => s.accessToken)
  return accessToken ? <Navigate to="/dashboard" /> : <Navigate to="/login" />
}
